import { useRef, useEffect } from "react";
import type { AnimationItem } from "lottie-web";

function LottieAnimation({ path }: { path: string }) {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    let animation: AnimationItem | null = null;
    let cancelled = false;

    // Lazy-load lottie-web so Lottie animations don't inflate the main bundle
    import("lottie-web")
      .then(({ default: lottie }) => {
        if (!containerRef.current || cancelled) return;
        animation = lottie.loadAnimation({
          container: containerRef.current,
          renderer: "svg",
          loop: true,
          autoplay: true,
          path,
        });
      })
      .catch((err) => {
        console.error("Failed to load lottie-web for LottieAnimation", err);
      });

    return () => {
      cancelled = true;
      if (animation) {
        animation.destroy();
      }
    };
  }, [path]);

  return <div ref={containerRef} className="w-full h-full" />;
}

export default LottieAnimation;